import {isNil, isEmpty, get} from 'lodash'
import {getSelectedDepartments, JobCardCreateType} from 'helpers/production/index'
import {accountHasFeature} from 'helpers/user'
import {features} from 'helpers/constants'
import {getDeliveredForOrderItem} from "helpers/deliveries"

export const getSelectableOrderItems = (orderItems, jobCards) =>
  orderItems.filter(orderItem => canSelectOrderItem(orderItem, jobCards))

export const canSelectOrderItem = (orderItem, jobCards) => {
  const quantityDelivered = getDeliveredForOrderItem(orderItem, orderItem.order.deliveryNotes)
  if (quantityDelivered >= get(orderItem, 'quantity')) return false
  return !jobCards.some(jobCard => jobCard.orderItemId === orderItem.id)
}

export const isValidDepartment = (department) => {
  const departmentId = department.departmentId
  const workCentreId = department.workCentreId

  return !isNil(departmentId) ||
      (departmentId === true && !isNil(workCentreId))
}


export const isAnyDepartmentSelected = (orderItems) => {
  return orderItems.reduce((previousDepartment, nextDepartment) => {
    const selectedDepartments = getSelectedDepartments(nextDepartment)
    if (isEmpty(selectedDepartments))
      return false

    const validDepartments = selectedDepartments.filter(isValidDepartment)
    return previousDepartment && !isEmpty(validDepartments)
  }, true)
}

export const getDefaultJobCardCreateType = (user) => {
  if (!accountHasFeature(user, features.LINE_ITEM_JOB_CARDS))
    return JobCardCreateType.JOB


  return get(user, 'settings.productionJobCreateType', JobCardCreateType.LINE_ITEM)
}

export const getJobCardNotesForWholeJob = (order) => {
  return order.orderitems.map(
      item =>
          `Item ${item.lineItemLetter} : ${item.quantity} x ${item.desc}` +
          `${item.notes ? '\n' + item.notes + '\n' : '\n'}`
  ).join('\n')
}

export const areLineItemJobCardsEnabled = (user) => {
  return accountHasFeature(user, features.LINE_ITEM_JOB_CARDS)
}
